import React from 'react';
import PropTypes from 'prop-types';

import './MomentNavigation.scss';

const propTypes = {
    nextAction: PropTypes.func,
    previousAction: PropTypes.func,
};

const MomentNavigation = ({ nextAction, previousAction }) => (
    <section className="MomentNavigation">
        <div className="MomentNavigation__hover-area MomentNavigation__hover-area--left">
            <button className="swiper-button-prev" type="button" aria-label="previous moment" onClick={previousAction} />
        </div>
        <div className="MomentNavigation__hover-area MomentNavigation__hover-area--right">
            <button className="swiper-button-next" type="button" aria-label="next moment" onClick={nextAction} />
        </div>
    </section>
);

MomentNavigation.propTypes = propTypes;

export default MomentNavigation;
